function setupImageSliders() {
  document.querySelectorAll(".product-item").forEach((card) => {
    const inner = card.querySelector(".image-inner");
    const imageWrapper = card.querySelector(".product-item__image-wrapper");
    const outer = card.querySelector(".image-container");
    const dotsContainer = card.querySelector(".slider-dots");

    if (!inner || !imageWrapper || !outer || !dotsContainer) return;

    let currentIndex = 0;
    let images = inner.querySelectorAll(".slider-image");

    let swipeListenersAttached = false;
    let buttonListenersAttached = false;

    function updateImageVisibility() {
      if (!images || images.length === 0) return;

      images.forEach((img, index) => {
        img.style.zIndex = index === currentIndex ? "1" : "0";
      });

      const dots = dotsContainer.querySelectorAll(".dot");
      dots.forEach((dot, index) => {
        dot.classList.toggle("active", index === currentIndex);
      });
    }

    function createDots() {
      dotsContainer.innerHTML = "";
      images.forEach((_, index) => {
        const dot = document.createElement("span");
        dot.classList.add("dot");
        if (index === currentIndex) dot.classList.add("active");

        dot.addEventListener("click", () => {
          currentIndex = index;
          updateImageVisibility();
        });

        dotsContainer.appendChild(dot);
      });
    }

    function attachButtonListeners() {
      if (buttonListenersAttached) return;
      buttonListenersAttached = true;

      const prevBtn = card.querySelector(".prev-btn");
      const nextBtn = card.querySelector(".next-btn");

      if (prevBtn) {
        prevBtn.addEventListener("click", () => {
          currentIndex = (currentIndex - 1 + images.length) % images.length;
          updateImageVisibility();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", () => {
          currentIndex = (currentIndex + 1) % images.length;
          updateImageVisibility();
        });
      }
    }

    function attachSwipeListeners() {
      if (swipeListenersAttached) return;
      swipeListenersAttached = true;

      let startX = 0;
      let startTime = 0;

      outer.addEventListener("touchstart", (e) => {
        startX = e.changedTouches[0].pageX;
        startTime = Date.now();
      });

      outer.addEventListener("touchend", (e) => {
        images = inner.querySelectorAll(".slider-image");

        const endX = e.changedTouches[0].pageX;
        const elapsedTime = Date.now() - startTime;
        const distance = endX - startX;

        const minDistance = 30;
        const maxTime = 1000;

        if (elapsedTime <= maxTime && Math.abs(distance) >= minDistance) {
          if (distance > 0) {
            currentIndex = (currentIndex - 1 + images.length) % images.length;
          } else {
            currentIndex = (currentIndex + 1) % images.length;
          }
          updateImageVisibility();
        }
      });
    }

    const observer = new MutationObserver(() => {
      images = inner.querySelectorAll(".slider-image");
      updateImageVisibility();

    });

    observer.observe(imageWrapper, { childList: true, subtree: true });

    // Initial setup
    createDots();
    updateImageVisibility();
    attachButtonListeners();
    attachSwipeListeners();
  });
}

document.addEventListener("DOMContentLoaded", () => {
  setupImageSliders();
});








function toggleProductGrid(lines) {
    
    const productGrid = document.querySelector('.product-facet__product-list .product-list__inner');
    
    productGrid.classList.remove('collection__page-products-3');
    productGrid.classList.remove('collection__page-products');
    productGrid.classList.remove('collection__page-products-2');
    productGrid.classList.remove('collection__page-products-1');
    
     if (lines === 2) {
        productGrid.classList.add('collection__page-products-2');
    } else if (lines === 1) {
        productGrid.classList.add('collection__page-products-1');
    }else if (lines === 3) {
        productGrid.classList.add('collection__page-products-3');
    }else if (lines === 4) {
        productGrid.classList.add('collection__page-products');
    }
    const gridButtons = document.querySelectorAll('.st-grid-changer button');
const currentColumns = parseInt(lines); // Assuming 'lines' is the variable containing the current column value

gridButtons.forEach(button => {
    const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
    const isActive = button.classList.contains('active');

    if (buttonColumns === currentColumns && !isActive) {
        button.classList.add('active'); // Add 'active' class
    } else if (buttonColumns !== currentColumns && isActive) {
        button.classList.remove('active'); // Remove 'active' class
    }
});

}

document.addEventListener('DOMContentLoaded', () => {
    const productGrid = document.querySelector('.product-facet__product-list .product-list__inner');
    const gridButtons = document.querySelectorAll('.st-grid-changer button');

    if (window.innerWidth <= 768) { 
        gridButtons.forEach(button => {
            const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
            if (buttonColumns === 2) {
                button.classList.add('active'); // Add 'active' class to button for collection__page-products-1
            } else {
                button.classList.remove('active'); // Remove 'active' from other buttons
            }
        });
        productGrid.classList.remove('collection__page-products-1'); // Mobile-specific class removal
    }
});

document.addEventListener('DOMContentLoaded', () => {
setTimeout(() => {
  let st_collection_cart_btn = document.querySelectorAll('#collectionmodalcontainer li.grid__item .card--product .card__content');
  if (st_collection_cart_btn.length > 0) {
    st_collection_cart_btn.forEach((button) => {
      if (!button.classList.contains("st-cart-btn")) {
        button.classList.add("st-cart-btn")
        button.innerHTML = button.innerHTML;
      }
    })
  }
}, 600)
});